import { IGetDroneRateCardsResponse } from 'services/droneService';

const determineFee = (
  rateCards: IGetDroneRateCardsResponse | null | undefined,
  weightClassCode: string | null | undefined,
  isRegisteredOverseas: boolean | undefined,
  isIntendedUseCommercial: boolean | undefined): number | undefined => {
  if (!weightClassCode) {
    return undefined;
  }
  // Retrieve RateCard for this Drone based on weight and origin
  if (isIntendedUseCommercial) {
    const rateCard = rateCards?.value?.value?.find(rateCard =>
      rateCard.droneweightclass_code === weightClassCode &&
      ((isRegisteredOverseas && rateCard.casa_feecode.substring(0, 2) === 'LF') ||
        ((!isRegisteredOverseas && rateCard.casa_feecode.substring(0, 2) === 'LC'))));

    return rateCard?.casa_rate;
  }
  const rateCard = rateCards?.value?.value?.find(rateCard =>
    rateCard.droneweightclass_code === weightClassCode &&
    ((isRegisteredOverseas && rateCard.casa_feecode.substring(0, 2) === 'RF') ||
      ((!isRegisteredOverseas && rateCard.casa_feecode.substring(0, 2) === 'RC'))));

  return rateCard?.casa_rate;
};

export default determineFee;
